var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Divider, Form, Input } from 'antd';
import axios from 'axios';
import styles from './Forms.module.scss';
import FloatLabel from '../../components/floatLable/FloatLabel';
import { history } from '../../_history';
import { useComponentLocale } from '../../hooks/useComponentLocale';
import { ErrorIcon } from "../../helpers/icons";
var ResetForm = function (_a) {
    var closeResetForm = _a.closeResetForm, isConfirmReset = _a.isConfirmReset;
    var _b = useState({
        email: '',
        password: '',
        confirmPass: '',
    }), resetFormData = _b[0], setResetFormData = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(false), isSendEmail = _d[0], setIsSendEmail = _d[1];
    var _e = useState(false), isPassChanged = _e[0], setIsPassChanged = _e[1];
    var _f = useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var getLocale = useComponentLocale();
    var inputEmailLocale = getLocale({ component: 'login_form', section: 'input_email' });
    var inputCorrectEmailLocale = getLocale({ component: 'login_form', section: 'input_correct_email' });
    var noSuchUserLocale = getLocale({ component: 'login_form', section: 'no_such_user' });
    var inputPasswordLocale = getLocale({ component: 'auth_page', section: 'input_new_pass' });
    var resetPassLocale = getLocale({ component: 'auth_page', section: 'reset_pass' });
    var confirmRejectLocale = getLocale({ component: 'auth_page', section: 'confirm_reject' });
    var resetInstrLocale = getLocale({ component: 'auth_page', section: 'instruct_reset' });
    var rememberPassLocale = getLocale({ component: 'auth_page', section: 'remember_pass' });
    var backToLoginLocale = getLocale({ component: 'auth_page', section: 'back_to_login' });
    var passChangedLocale = getLocale({ component: 'auth_page', section: 'pass_changed' });
    var confirmPassLocale = getLocale({ component: 'auth_page', section: 'confirm_pass' });
    var inputConfirmLocale = getLocale({ component: 'auth_page', section: 'input_confirm' });
    var passwordLocale = getLocale({ component: 'login_form', section: 'password' });
    var loginBtnLocale = getLocale({ component: 'common_buttons', section: 'login' });
    var emailLocale = getLocale({ component: 'login_form', section: 'email' });
    var backToLoginFrom = function () {
        isConfirmReset && history.push('/');
        closeResetForm(false);
    };
    var handleResetData = function (property, inputValue) {
        setResetFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[property] = inputValue, _a)));
        });
    };
    var sendEmailToResetPass = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var body, url, restorePassEmail;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = new URLSearchParams();
                    body.append('x_name', value.username);
                    body.append('x_referer', 'GTOBase');
                    url = 'https://reserve.simplepostflop.com/signupn/password_restore.php';
                    setIsLoading(true);
                    return [4 /*yield*/, axios.post(url, body, {
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        })];
                case 1:
                    restorePassEmail = _a.sent();
                    if (restorePassEmail.data.state === 'success') {
                        setIsSendEmail(true);
                        setIsLoading(false);
                    }
                    else {
                        setError(restorePassEmail.data.error_code);
                        setIsLoading(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var resetPasswordFinally = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var searchParams, ampersandIndx, lastIndexEqual, userEmailURL, userTokenURL, body, url, resetPassFinally;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    searchParams = history.location.search;
                    ampersandIndx = searchParams.indexOf('&');
                    lastIndexEqual = searchParams.lastIndexOf('=');
                    userEmailURL = searchParams.slice(7, ampersandIndx).replace('%40', '@');
                    userTokenURL = searchParams.slice(lastIndexEqual + 1);
                    setIsLoading(true);
                    body = new URLSearchParams();
                    body.append('hidden_email', userEmailURL);
                    body.append('hidden_restore', userTokenURL);
                    body.append('x_new_pswd', value.password);
                    body.append('x_conf_new_pswd', value.confirmPassword);
                    url = 'https://reserve.simplepostflop.com/signupn/password_change.php';
                    return [4 /*yield*/, axios.post(url, body, {
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        })];
                case 1:
                    resetPassFinally = _a.sent();
                    if (resetPassFinally.data.state === 'success') {
                        setIsPassChanged(true);
                        setIsSendEmail(true);
                        setIsLoading(false);
                    }
                    else {
                        setError(resetPassFinally.data.error_code);
                        setIsLoading(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getErrorMessage = function (error) {
        if (error === 1002) {
            return (_jsxs("p", __assign({ className: styles.errorTextContainer }, { children: [_jsx("div", { children: _jsx(ErrorIcon, {}) }), _jsx("div", __assign({ className: styles.errorText }, { children: _jsx("h4", __assign({ className: styles.titleError }, { children: noSuchUserLocale })) }))] })));
        }
        return (_jsxs("p", __assign({ className: styles.errorTextContainer }, { children: [_jsx("div", { children: _jsx(ErrorIcon, {}) }), _jsx("div", __assign({ className: styles.errorText }, { children: _jsx("h4", __assign({ className: styles.titleError }, { children: error })) }))] })));
    };
    var renderResetForm = function () {
        if (isConfirmReset) {
            return (_jsxs(Form, __assign({ className: styles.formBody, name: 'basic', onFinish: resetPasswordFinally }, { children: [_jsx(Form.Item, __assign({ name: 'password', validateTrigger: 'none', className: styles.formItemInputs, rules: [{ required: true, message: inputPasswordLocale, validateTrigger: 'onSubmit' }] }, { children: _jsx(FloatLabel, __assign({ label: passwordLocale, text: resetFormData.password }, { children: _jsx(Input.Password, { value: resetFormData.password, className: styles.formInput, onChange: function (e) { return handleResetData('password', e.target.value); } }) })) })), _jsx(Form.Item, __assign({ name: 'confirmPassword', className: [styles.formItemInputs, styles.marginTop].join(' '), dependencies: ['password'], rules: [
                            {
                                required: true,
                                message: inputConfirmLocale,
                                validateTrigger: 'onSubmit',
                            },
                            function (_a) {
                                var getFieldValue = _a.getFieldValue;
                                return ({
                                    validator: function (_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error(confirmRejectLocale));
                                    },
                                });
                            },
                        ] }, { children: _jsx(FloatLabel, __assign({ label: confirmPassLocale, text: resetFormData.confirmPass }, { children: _jsx(Input.Password, { value: resetFormData.confirmPass, className: styles.formInput, onChange: function (e) { return handleResetData('confirmPass', e.target.value); } }) })) })), _jsx(Form.Item, __assign({ className: [styles.formItemOther, styles.marginTop].join(' ') }, { children: _jsx(Button, __assign({ type: 'primary', htmlType: 'submit', size: 'middle', block: true, className: styles.resetBtn, loading: isLoading }, { children: resetPassLocale })) }))] })));
        }
        return (_jsxs(Form, __assign({ className: styles.formBody, name: 'basic', onFinish: sendEmailToResetPass }, { children: [_jsx("span", { children: "Email" }), _jsx(Form.Item, __assign({ name: 'username', className: styles.formItemInputs, rules: [
                        { required: true, message: inputEmailLocale, validateTrigger: 'onSubmit' },
                        { type: 'email', message: inputCorrectEmailLocale, validateTrigger: 'onSubmit' }
                    ] }, { children: _jsx(Input, { value: resetFormData.email, className: styles.formInput, onChange: function (e) { return handleResetData('email', e.target.value); }, placeholder: emailLocale }) })), error && _jsx(Form.Item, __assign({ style: { marginBottom: 0 } }, { children: getErrorMessage(error) })), _jsx(Form.Item, __assign({ className: [styles.formItemOther, styles.marginTop].join(' ') }, { children: _jsx(Button, __assign({ loading: isLoading, type: 'primary', htmlType: 'submit', size: 'middle', block: true, className: styles.resetBtn }, { children: resetPassLocale })) }))] })));
    };
    var renderBodyText = function () {
        return isConfirmReset ? (_jsx("span", __assign({ className: styles.resetInstructions }, { children: passChangedLocale }))) : (_jsx("span", __assign({ className: styles.resetInstructions }, { children: resetInstrLocale })));
    };
    return (_jsxs("div", __assign({ className: styles.resetFormContainer }, { children: [_jsxs("div", { children: [_jsx("div", __assign({ className: styles.cardTitle }, { children: resetPassLocale })), isSendEmail ? renderBodyText() : renderResetForm()] }), isPassChanged ? (_jsx(Button, __assign({ type: 'primary', size: 'middle', className: styles.resetFinalBtn, onClick: backToLoginFrom }, { children: loginBtnLocale }))) : (_jsxs("div", { children: [_jsx(Divider, { className: styles.divider }), _jsxs("div", __assign({ className: styles.resetFooterText }, { children: [_jsx("span", { children: rememberPassLocale }), _jsx("span", __assign({ onClick: backToLoginFrom }, { children: backToLoginLocale }))] }))] }))] })));
};
export default ResetForm;
